import { SpecialAnchorTypes, ToolTypes } from '@labradorsports/constants';

import { PluginContext } from '../../plugins/api.js';
import {
    generateOptionAnchors,
    generateOptionLines,
    generateOptionSelectedAnchors,
    getDefaultOptionMove,
    handleOptionDrag,
    handleOptionDragEnd,
} from '../../utils/index.js';
import { getFootballToolFrameIdx } from '../move-placement-frame.js';

const footballOptionOptions = { defaultToMoveEnd: true };

export default {
    types: [ToolTypes.OPTION, SpecialAnchorTypes.OPTION_START],

    generateAnchors: ({ play }) => {
        const anchors = [];

        if (!play.fieldSetup) {
            play.frameSnapshots.forEach((frame, frameIdx) => {
                anchors.unshift(
                    ...generateOptionAnchors({ play, frame }).map((a) => ({
                        ...a,
                        frameIdx,
                    }))
                );
            });
        }

        return anchors;
    },

    generateSelectedAnchors: generateOptionSelectedAnchors,

    generateLines: ({ play }) => {
        if (play.fieldSetup) return [];

        return play.frameSnapshots.flatMap((frame, frameIdx) =>
            generateOptionLines({ play, frame }).map((line) => ({
                ...line,
                frameIdx,
            }))
        );
    },

    handleDragEnd: ({ api, play, lines, fieldViewport }, anchor, offset) => {
        const frameIdx = getFootballToolFrameIdx(anchor);
        const frame = play.frameSnapshots[frameIdx];

        const wrappedApi = {
            ...api,
            updateOption: (update: any) => {
                api.updateOption(update, frameIdx);
            },
            removeMove: (update: any) => {
                api.removeMove({ ...update, frameIdx });
            },
        };

        handleOptionDragEnd(
            { api: wrappedApi, play, lines, fieldViewport, frame },
            anchor,
            offset,
            footballOptionOptions
        );
    },

    handleDrag({ play, lines, api, fieldViewport, frames }, anchor, offset) {
        const frameIdx = getFootballToolFrameIdx(anchor);
        const frame = frames[frameIdx];

        return handleOptionDrag(
            {
                play,
                lines,
                api,
                frame,
                fieldViewport,
            },
            anchor,
            offset,
            footballOptionOptions
        );
    },

    getDefaultMove({ play, lines, fieldViewport }, type, offset) {
        const frameIdx = getFootballToolFrameIdx({ type });
        const optionFrame = play.frameSnapshots[frameIdx];

        return getDefaultOptionMove(
            { play, lines, fieldViewport, frame: optionFrame },
            type,
            offset,
            footballOptionOptions
        );
    },
} as PlayPlugin<PluginContext>;
